/** Rader under overskrift som kan dra/slippes (produksjonsplan + plan-mal). */
export function isPlanRadSortable(el: { type: string } | null | undefined): boolean {
  if (!el) return false;
  return (
    el.type === 'hendelse' ||
    el.type === 'sang' ||
    el.type === 'musikk_placeholder'
  );
}
